export default __webpack_public_path__ + "static/3-12fee9b9060ddab7c21440af50e193b8.jpg";